import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import { DashboardLocationCard } from '../dashboardTypes'
import LocationCountrySections from './LocationCountrySections'

const EmptyState = styled.div`
  padding: 1.5rem;
  border: 1px dashed ${palette.grey.grey300};
  border-radius: 0.75rem;
  text-align: center;
`

interface LocationCardsRowProps {
  cards?: DashboardLocationCard[] | null
  isLoading?: boolean
  groupBy?: 'country' | 'region'
  onCardClick: (card: DashboardLocationCard) => void
}

const LocationCardsRow = ({
  cards = null,
  isLoading = false,
  groupBy = 'country',
  onCardClick,
}: LocationCardsRowProps) => {
  const showLoading = isLoading || cards === null
  const hasCards = (cards?.length ?? 0) > 0

  if (showLoading) {
    return (
      <EmptyState data-cy='location-cards-row'>
        <Text variant='body1' color={palette.text.secondary}>
          Loading locations…
        </Text>
      </EmptyState>
    )
  }

  if (!hasCards) {
    return (
      <EmptyState data-cy='location-cards-row'>
        <Text variant='body1' color={palette.text.secondary}>
          No active locations yet
        </Text>
      </EmptyState>
    )
  }

  return (
    <LocationCountrySections
      cards={cards!}
      groupBy={groupBy}
      onCardClick={onCardClick}
    />
  )
}

export default React.memo(LocationCardsRow)
